export default {
  GET_SUPPORTED_LANGUAGES: "GET_SUPPORTED_LANGUAGES",
  GET_APP_CONFIG_BY_KEY: "GET_APP_CONFIG_BY_KEY",
};
